// src/store/reducers/seasonsReducer.js
import { GET_SEASONS_REQUEST, GET_SEASONS_SUCCESS, GET_SEASONS_FAIL, ADD_SEASON, UPDATE_SEASON, DELETE_SEASON } from "../actions/seasonsActions";

const initialState = { loading: false, list: [], error: null };

export default function seasonsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SEASONS_REQUEST:
      return { ...state, loading: true };
    case GET_SEASONS_SUCCESS:
      return { ...state, loading: false, list: action.payload || [] };
    case GET_SEASONS_FAIL:
      return { ...state, loading: false, error: action.payload };
    case ADD_SEASON:
      return { ...state, list: [action.payload, ...state.list] };
    case UPDATE_SEASON:
      return { ...state, list: state.list.map((s) => (s._id === action.payload._id ? action.payload : s)) };
    case DELETE_SEASON:
      return { ...state, list: state.list.filter((s) => s._id !== action.payload._id) };
    default:
      return state;
  }
}
